export default __webpack_public_path__ + "static/media/contrast_light_background.cc61e090.svg";